import * as React from 'react';
import { SampleEditor } from './SampleEditor'
import './App.css'

export function App() {
  return (
    <SampleEditor initialText="Thiz iz an texd thad iz fuls ov errorrs.." />
  );
}
